import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type SessionContextService from 'tio-employee/services/session-context';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type PersonModel from 'tio-common/models/person';
import type EmployeeService from 'tio-employee/services/employee';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AccountActivityAccountsRouteModel = Resolved<
  ReturnType<AuthenticatedAccountActivityAccountsRoute['model']>
>;

export default class AuthenticatedAccountActivityAccountsRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare employee: EmployeeService;

  async model() {
    // Refresh contribution data when navigating to this route (fixes DEV-4638)
    // This ensures contribution amounts display after loan upload without requiring a page refresh
    if (this.employee.contributionsState.isFinished) {
      this.employee.contributionsState.retry();
    }
    if (this.employee.futurePayments.isFinished) {
      this.employee.futurePayments.retry();
    }

    const personId = this.sessionContext.user.person.id;
    // @ts-expect-error type model
    return this.store.findRecord<PersonModel>('person', personId, {
      include:
        'accounts.loans,accounts.financial-institution,accounts.postal-address,employees.plan',
      reload: true,
    });
  }
}
